import React from "react";
import TournamentCard from "./TournamentCard";

const TournamentGrid = ({ tournaments }) => {
  return (
    <>
      <p className="text-sm text-brand-muted mb-2">
        {tournaments.length} tournament{tournaments.length !== 1 ? "s" : ""}
      </p>

      {tournaments.length === 0 ? (
        <p className="py-10 text-brand-muted max-w-xl">
          No dates match these filters.
        </p>
      ) : (
        <div className="border-t border-brand-charcoal/15">
          {tournaments.map((tournament) => (
            <TournamentCard key={tournament.id} tournament={tournament} />
          ))}
        </div>
      )}
    </>
  );
};

export default TournamentGrid;
